import { render, staticRenderFns } from "./theme-select-wrap.vue?vue&type=template&id=85919dae&"
import script from "./theme-select-wrap.vue?vue&type=script&lang=js&"
export * from "./theme-select-wrap.vue?vue&type=script&lang=js&"
import style0 from "./theme-select-wrap.vue?vue&type=style&index=0&id=85919dae&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports